import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconBumps = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#fff"
      d="m2.876 2.193 3.98-1.103c1.057-.283 2.14.113 2.79 1.018l1.489 2.12c.677.085 1.273.594 1.462 1.329l1.246 4.806c.108.48-.163.99-.623 1.131l-.84.226c-.46.114-.92-.17-1.056-.65L11 9.77l-7.527 2.092.325 1.329c.135.48-.162.96-.623 1.102l-.84.226c-.46.142-.92-.141-1.055-.622L.06 9.091c-.19-.763.082-1.498.623-1.922l.27-2.63c.136-1.13.894-2.035 1.923-2.346Zm.46 1.752c-.351.085-.595.396-.65.792l-.189 1.781 6.77-1.894-1.03-1.442c-.216-.31-.568-.452-.92-.34l-3.98 1.103Zm-.324 6.192c.46-.141.73-.65.623-1.13-.136-.481-.623-.764-1.084-.623-.46.113-.73.622-.595 1.103a.872.872 0 0 0 1.056.65Zm7.094-3.873c-.46.141-.758.622-.623 1.102.136.481.596.792 1.056.65a.932.932 0 0 0 .623-1.102c-.135-.48-.596-.763-1.056-.65ZM11.216 15c-.514 0-.92-.48-.677-.99.488-1.017 1.517-1.724 2.68-1.724a3.01 3.01 0 0 1 2.709 1.725c.243.508-.163.989-.704.989h-4.008Z"
    />
  </svg>
));
export default SvgIconBumps;
